<template lang="html">
    <div class="content">
        <div class="image image-tools"></div>
        <p>
            De Broeders van La Force delen graag enkele artikelen die een inkijkje geven in de over&shy;wegingen ten aanzien van enkele hele specifieke onderwerpen.
        </p>
        <hr />
        <p class="cloud">
            <span class="status"> Ontvangen vandaag om {{ getTime() }}. </span>
            <!-- <h2>Het geheim van Wijsheid </h2> -->
            <span class="bubble r">
                <span class="inner ir">Wat is het geheim van wijsheid?</span>
            </span>

            <span class="bubble l">
                <span class="inner il">Ga nooit in discussie met een 🤡 !</span>
            </span>

            <span class="bubble r">
                <span class="inner ir">Dat ben ik niet met u eens.</span>
            </span>

            <span class="bubble l">
                <span class="thinner il super">🤦🏻‍♂️</span>
            </span>
            <!-- <br /> -->
            <!-- <br /> -->
            <!-- <span> Het gaat er niet altijd om wie er gelijk heeft. Soms gaat het er bijvoorbeeld om wat je ergens mee op schiet. Of wat het beste zou zijn in een ander kader. Nieuwe invalshoeken kunnen bijna altijd door iedereen gewaardeerd worden, zolang ze waar(lijk) zijn en gedeeld worden in een sfeer van wederzijds vertrouwen en respect. </span> -->
        </p>
        <hr />
        <!-- <p>
            Met enige regelmaat schrijven de Broeders van de Loge La Force kleine stukjes die een inkijkje geven in de over&shy;wegingen ten aanzien van een paar hele specifieke onderwerpen. Misschien interessant voor een zoekende mens...
        </p> -->
        <div class="f-c">
            <div class="f-1">
                <!-- <p class="question">Artikelen.</p> -->
                <AndereArtikelen></AndereArtikelen>
            </div>
            <div class="f-1">
                &nbsp;
            </div>
        </div>
        <p class="quote">"Waar ligt de grens tussen jezelf zijn en onderdeel zijn van een groter geheel?" <span class="author">~ Anonieme broeder. </span></p>
        <Proceedings></Proceedings>
    </div>
</template>

<script>

import Proceedings from './Proceedings'
import AndereArtikelen from './AndereArtikelen'

export default {
    components: {
        Proceedings,
        AndereArtikelen
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    methods: {
        getTime: () => {
            const dt = new Date()
            return ('0' + dt.getHours()).slice(-2) + ':' + ('0' + (dt.getMinutes() - 3)).slice(-2)
        }
    }
}

</script>

<style lang="css" scoped>

    .cloud {
        background: #151629;
        padding: 60px 60px;
        border-radius: 3px;
    }

    .bubble {
        display: block;
        padding: 20px;
        position: relative;
        /* background: yellow; */
    }

    .inner {
        border: solid 1px #5cacba;
        border-radius: 10px;
        color: #5cacba;
        padding: 10px;
        position: relative;
    }

    /* // klein scherm dan display block op die inner */



    .inner::before {
        position: absolute;
        content: '';
        display: inline-block;
        width: 14px;
        height: 14px;
        background: linear-gradient(to bottom left, #5cacba 50%, #151629 50%);
        bottom: -14px;
        left: 20px;
    }

    .inner::after {
        position: absolute;
        content: '';
        display: inline-block;
        width: 12px;
        height: 12px;
        background: linear-gradient(to bottom left, #151629 50%, transparent 50%);
        bottom: -12px;
        left: 21px;
    }

    .l {
        text-align: left;
    }

    .r {
        text-align: right;
    }

    .il::before {
        background: linear-gradient(to bottom right, #5cacba 50%, #151629 50%);
        left: auto;
        right: 21px;
    }
    .il::after {
        background: linear-gradient(to bottom right, #151629 50%, transparent 50%);
        left: auto;
        right: 22px;
    }

    .ir {

    }

    .super {
        font-size: 250%;
    }

    .status {
        font-size: 70%;
    }

    .image-tools {
        background: transparent url('/images/tools.jpg') no-repeat center center;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    ul {
        /* margin: 0;
        padding: 0;
        list-style-type: none; */
    }
    li {
        color: white;
        font-size: 19px;
    }
    @media only screen and (min-device-width : 320px) and (max-device-width : 667px) and (orientation : portrait) {
        .inner {
            display: block;
        }
        .cloud {
            padding: 10px;
        }
    }
</style>
